import React, { useState, useEffect } from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Text,
  HStack,
  Box,
} from '@chakra-ui/react';
import { FiClock } from 'react-icons/fi';

/**
 * Rate Limit Error Component
 * Displays user-friendly rate limit error with countdown timer
 */
const RateLimitError = ({ message, retryAfter, onComplete, ...props }) => {
  const [countdown, setCountdown] = useState(retryAfter || 900);

  useEffect(() => {
    if (countdown <= 0) {
      if (onComplete) onComplete();
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          if (onComplete) onComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, onComplete]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    
    if (minutes > 0) {
      return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    }
    return `${remainingSeconds}s`;
  };

  return (
    <Alert 
      status="warning" 
      borderRadius="md" 
      variant="left-accent"
      {...props}
    >
      <AlertIcon />
      <Box flex="1">
        <AlertTitle fontSize="sm" fontWeight="600">
          Rate Limit Exceeded
        </AlertTitle>
        <AlertDescription fontSize="sm" mt={1}>
          <Text>{message || 'Too many requests. Please try again later.'}</Text>
          {countdown > 0 && (
            <HStack spacing={1} mt={2} color="orange.700">
              <FiClock size={14} />
              <Text fontSize="xs" fontWeight="500">
                Please try again in {formatTime(countdown)}
              </Text>
            </HStack>
          )}
        </AlertDescription>
      </Box>
    </Alert>
  );
};

export default RateLimitError;

